const INITIAL_COLORS = {
  backgroundColors: [
    '#F5D7F7',
    '#D78DD6',
    '#F8BBD0',
    '#B01BAE',
    '#4F034C',
    '#C4B0DE',
    '#7A52B1',
    '#471692',
  ],
  hoverBackgroundColors: [
    '#f5d7f74d',
    '#d78dd64d',
    '#f8bbd04d',
    '#b01bae4d',
    '#4f034c4d',
    '#c4b0de4d',
    '#7a52b14d',
    '#4716924d',
  ],
};

export const centerTextPlugin = () => ({
  id: 'centerText',
  beforeDraw: (chart: any) => {
    const opts = chart?.config?.options;
    const rejectedApptsAmount = opts?.plugins?.centerText?.text ?? '';

    const { width, height, ctx } = chart;
    ctx.save();

    const lines = [
      rejectedApptsAmount.toLocaleString('en-US'),
      'Rejected appts',
    ];
    const fontFamily = 'Nexa';
    const lineHeight = 25;

    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = '#B01BAE';

    const centerX = width / 2;
    const centerY = height / 2;
    const totalHeight = lines.length * lineHeight;
    const startY = centerY - totalHeight / 2 + lineHeight / 2;

    lines.forEach((line, i) => {
      ctx.font =
        i === 0 ? 'bold 24px ' + fontFamily : 'bold 12px ' + fontFamily;
      ctx.fillText(line, centerX, startY + i * lineHeight);
    });

    ctx.restore();
  },
});

export const calculateBackgroundColors = ({
  selectedIndexByClick,
  selectedIndexByHover,
}: {
  selectedIndexByClick: number | null;
  selectedIndexByHover: number | null;
}) => {
  if (selectedIndexByClick !== null) {
    return {
      backgroundColor: INITIAL_COLORS.hoverBackgroundColors.map((_, index) => {
        return selectedIndexByClick === index
          ? INITIAL_COLORS.backgroundColors[index]
          : '#b3b3b34d';
      }),
      hoverBackgroundColor: INITIAL_COLORS.hoverBackgroundColors.map(
        (_, index) => {
          return selectedIndexByClick === index
            ? INITIAL_COLORS.backgroundColors[index]
            : INITIAL_COLORS.hoverBackgroundColors[index];
        }
      ),
    };
  } else if (selectedIndexByHover !== null) {
    return {
      hoverBackgroundColor: INITIAL_COLORS.hoverBackgroundColors.map(
        (_, index) => {
          return selectedIndexByHover === index
            ? INITIAL_COLORS.backgroundColors[index]
            : INITIAL_COLORS.hoverBackgroundColors[index];
        }
      ),
      backgroundColor: INITIAL_COLORS.hoverBackgroundColors.map((_, index) => {
        return selectedIndexByHover === index
          ? INITIAL_COLORS.backgroundColors[index]
          : '#b3b3b34d';
      }),
    };
  } else {
    return {
      backgroundColor: INITIAL_COLORS.backgroundColors,
      hoverBackgroundColor: ['#b3b3b34d'],
    };
  }
};

export const optionConfig = {
  cutout: '60%',
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      backgroundColor: '#fff',
      titleColor: '#373737',
      bodyColor: '#373737',
      borderWidth: 1,
      borderColor: '#E8E8E8',
      bodyFont: {
        family: 'Nexa',
      },
      caretSize: 0,
    },
  },
};
